import React from 'react';
import Nav from './../components/nav';
import Page from './../components/page';
import Menu from './../components/menu';
import './../styles/main.styl';
require('typeface-playfair-display');
require('typeface-crimson-text');

export default ({ children }) =>
  <div>
      <Nav />
      <Page>{children()}</Page>

      <Menu />
  </div>



// WEBPACK FOOTER //
// ./src/layouts/index.js